
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/[make]/[model]/[year]",
      function () {
        return require("private-next-pages/cars/[make]/[model]/[year].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/[make]/[model]/[year]"])
      });
    }
  